const TabSwitcher = ({ tab, setTab }) => (
  <div className="mb-4 flex gap-2 px-2">
    {['original', 'filtered', 'parsed', 'preview'].map((t) => (
      <button
        key={t}
        onClick={() => setTab(t)}
        className={`px-4 py-1 rounded ${
          tab === t ? 'bg-blue-600 text-white' : 'bg-gray-200'
        }`}
      >
        {t === 'original' ? 'Dữ liệu gốc' : t === 'filtered' ? 'Dữ liệu lọc' : t === 'parsed' ? 'Dữ liệu đã chuyển đổi' : 'Xem trước dữ liệu import'}
      </button>
    ))}
  </div>
);
export default TabSwitcher;
